import { type FC, useState } from "react";
import { getTimeDisplay } from "utils/relative-time";

export type RelativeTimeDisplayProps = {
  date: Date | string;
  className?: string;
  showTooltip?: boolean;
};

export const RelativeTimeDisplay: FC<RelativeTimeDisplayProps> = ({
  date,
  className = "",
  showTooltip = true,
}) => {
  // ホバーとクリックの状態
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  // 相対時間と絶対時間の両方を管理
  const timeDisplay = getTimeDisplay(date);

  // ホバーまたはクリック時に絶対時間を表示
  const shouldShowAbsolute = isHovered || isClicked;
  const displayText = shouldShowAbsolute
    ? timeDisplay.absolute
    : timeDisplay.relative;

  // ホバー
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  // 非ホバー
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  // クリックでオンとオフ
  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  return (
    <span
      className={`cursor-pointer transition-colors duration-200 ${
        shouldShowAbsolute ? "text-blue-600" : ""
      } ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      // ホバー時に絶対時間を表示
      title={showTooltip ? timeDisplay.absolute : undefined}
    >
      {displayText}
    </span>
  );
};
